// extracted by mini-css-extract-plugin
module.exports = {"title":"Security_title_3B5LE","subTitle":"Security_subTitle_bzMsd"};